import { configureStore } from '@reduxjs/toolkit'
import AuthSlice from "./slices/AuthSlice";
import UserSlice from "./slices/UserSlice";
import DeviceSlice from "./slices/DeviceSlice";
import CollapsedSlice from "./slices/CollapsedSlice";
import SideBarSlice from "./slices/SideBarSlice";

export default configureStore({
    reducer: {
        auth: AuthSlice,
        user: UserSlice,
        device: DeviceSlice,
        collapsed: CollapsedSlice,
        sider: SideBarSlice
    }
})
